module.exports = {
      id: "appstore-usage",
      viewBox: "0 0 96 32",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#appstore",
      toString: function () {
        return this.url;
      }
    }